import { Component, OnInit } from '@angular/core';
import { OrderService } from '../../services';

export enum JobType {
  Driven = 1,
  Transported = 2,
  Recovered = 3,
}

export enum TaskType {
  DrivenPlated = 1,
  DrivenUninsured = 2,
  UncoveredTransportedMovement = 3,
  CoveredTransportedMovement = 4,
  RecoveredSkates = 5,
  RecoveredFullLiftOnly = 6,
  RecoveredMoreEquipmentNeeded = 7,
  DriverInsured = 9,
}

@Component({
  selector: 'vme-jobs',
  templateUrl: './vme-jobs.component.html',
})
export class VmeJobsComponent implements OnInit {
  public joblist = [];
  public isLoaded: boolean = false;
  public selecteditem: any;
  public selectedTask: any;
  public sTasks: any[];
  constructor(private jobService: OrderService) {}

  ngOnInit() {
    this.selectedTask = null;
    this.selecteditem = null;
    this.sTasks = [];
    this.jobService.get().then((result) => {
      this.joblist = result;
      this.isLoaded = true;
    });
  }

  onRowSelect(event) {
    console.log(event.data);

    //var temp = event.data;
    //temp.tasks.forEach(item => this.sTasks.push(this.initDates(item)));

    this.selecteditem = event.data;
    //this.sTasks = [];
    //this.selecteditem.tasks.forEach(item => this.sTasks.push(this.initDates(item)));
    //this.selectedTask = this.sTasks[0];
  }

  private initDates(obj: any): any {
    return Object.assign(
      {},
      ...(function _f(o) {
        return [].concat(
          ...Object.keys(o).map((k) =>
            [
              'pickupEarliestDateTime',
              'pickupLatestDateTime',
              'dropoffEarliestDateTime',
              'dropoffLatestDateTime',
            ].indexOf(k) >= 0
              ? { [k]: new Date(o[k]) }
              : { [k]: o[k] },
          ),
        );
      })(obj),
    );
  }

  getTaskType() {
    switch (this.selectedTask.taskTypeId) {
      case null:
      case undefined:
        return '';
      case TaskType.DrivenPlated:
      case TaskType.DrivenUninsured:
      case TaskType.DriverInsured:
        return 'Driven';
      case TaskType.UncoveredTransportedMovement:
      case TaskType.CoveredTransportedMovement:
        return 'Transported';
      case TaskType.RecoveredSkates:
      case TaskType.RecoveredFullLiftOnly:
      case TaskType.RecoveredMoreEquipmentNeeded:
        return 'Recovered';
      default:
        return '';
    }
  }
}
